export const RtfToHtml = (rtf = "") => {
  if (!rtf) return "";

  let html = rtf;

  // 1. Remove RTF header safely
  // html = html.replace(/{\\rtf1[\s\S]*?\\viewkind\d+\s*/g, "");
  html = html.replace(/{\s*\\rtf1[\s\S]*?\\viewkind\d+\s*/g, "");

  // 2. Remove font table
  html = html.replace(/\\fonttbl[\s\S]*?;/g, "");

  // Remove raw line breaks from source (these are not real content breaks)
  html = html.replace(/\r?\n/g, " ");

  // 3. Convert RTF paragraph breaks to <br> (1:1 mapping, koi loss nahi)
  // html = html.replace(/\\par\s*/g, "<br>");
  html = html.replace(/\\par(?![a-zA-Z])\s*/g, "<br>");

  html = html.replace(
  /{\s*\\field{\s*\\\*\\fldinst\s+HYPERLINK\s+"([^"]+)"\s*}{\s*\\fldrslt\s+([^}]*)}/gi,
  '<a href="$1">$2</a>'
);

  // 4. Bold + italic + underline combinations
  html = html.replace(/\\b\\i\\ul\s(.*?)\\b0\\i0\\ulnone/g, "<strong><em><u>$1</u></em></strong>");
  html = html.replace(/\\b\\i\s(.*?)\\b0\\i0/g, "<strong><em>$1</em></strong>");
  html = html.replace(/\\b\\ul\s(.*?)\\b0\\ulnone/g, "<strong><u>$1</u></strong>");
  html = html.replace(/\\i\\ul\s(.*?)\\i0\\ulnone/g, "<em><u>$1</u></em>");

  // 5. Single styles
  html = html.replace(/\\b\s(.*?)\\b0/g, "<strong>$1</strong>");
  html = html.replace(/\\i\s(.*?)\\i0/g, "<em>$1</em>");
  html = html.replace(/\\ul\s(.*?)\\ulnone/g, "<u>$1</u>");

  // 6. Remove leftover RTF commands safely

  // html = html.replace(/\\[a-zA-Z]+\d* ?/g, "");
  html = html.replace(/\\[a-zA-Z]+(?:-?\d+)?(?=\s|\\|{|}|$)/g, "");

  // 7. Remove braces
  html = html.replace(/[{}]/g, "");

  // 8. Remove weird artifacts (safe cleanup)
  html = html.replace(/\b[d]\b/g, "");

  // 9. Trim leading/trailing <br> only (extra blank lines beech mein touch nahi karna)
  // html = html.replace(/^(<br>\s*)+/, "").replace(/(<br>\s*)+$/, "");
  html = html.replace(/^[\s]*(<br>[\s]*)+/, "").replace(/(<br>[\s]*)+[\s]*$/, "");

  return html.trim();
};